/**
 * created by xcc on 2021/10/20
 * 新媒体管理的action
 */

import request, {RequestFile} from "../../../base/request";
import {applicationName} from "../../../utils";
import {formateData} from "../../../actions";
import {getInfoFromLocalStorage} from "../../../actions/index";

let headers = {
    "Content-Type": 'application/json;charset=UTF-8'
};
let host = "/cm-sites-" + applicationName() + '/';
let serviceHost = '/newmedia-business-server/';

const Apis = {
    getInitMediaPlatformData: serviceHost + 'newMediaType/getAllNewMediaTypeNoPage',//获取初始化媒体平台数据
    getRecordDeptByIds: '/cm-sites-sys/dept/getDeptAndSon',//新媒体矩阵新增媒体主责单位获取(全部)
    getCurrentDeptByIds: '/cm-sites-sys/dept/getByIds',//新媒体矩阵新增媒体主责单位获取（当前）
    getNewMediaListData: serviceHost + 'newMedia/newMediaList',//获取新媒体列表数据
    getAllNewMediaList: serviceHost + "newMedia/allNewMediaList",//获取所有媒体
    getMeHandleCountData: serviceHost + 'newMedia/newMediaCount',//获取待我处理数量
    addNewMedia: serviceHost + 'newMedia/addNewMedia',//新增媒体
    updateNewMedia: serviceHost + 'newMedia/updateNewMedia',//更新媒体
    getNewMediaById: serviceHost + 'newMedia/newMedia',//根据id查询媒体
    newMediaList: serviceHost + 'newMedia/newMediaList',//媒体列表
    checkName: serviceHost + 'newMedia/checkName',//验证媒体名称
    checkDouyinLink: serviceHost + 'newMedia/checkDouyinLink',//验证抖音链接;
    cancelExport: serviceHost + 'newMedia/cancelImport',//取消导入;
    addSingleData: serviceHost + 'newMedia/addSingleData',//批量导入的新增单条数据;
    editSingleData: serviceHost + 'newMedia/editSingleData',//批量导入的修改单条数据;
    batchUpdateNewMedia: serviceHost + 'newMedia/batchUpdateNewMedia',//批量更新的转交和审核;
    cancelImport: serviceHost + 'newMedia/cancelImport',//批量导入的取消;
    deleteData: serviceHost + 'newMedia/deleteData',//批量导入的删除;
    deleteNewMediaById: serviceHost + 'newMedia/deleteNewMediaById',//根据媒体ID删除媒体;
    updateNewMediaStatusName: serviceHost + 'newMedia/updateNewMediaStatusName',//根据媒体ID更新媒体状态;
    getExcelTemplate: serviceHost + 'fileHandler/outputNewMediaImportTemplate',//获取下载模板;
    saveExcelTemplate: serviceHost + 'newMedia/saveExcelTemplate',//导入模板;
    getTransferUsers: '/cm-sites-sys/user/getUserSpecialNeeds', //获取被转交人(除过当前用户)
    batchTransferNewMedias: serviceHost + 'newMedia/batchTransferNewMedias', //获取被转交媒体列表
    transferNewMedias: serviceHost + 'newMedia/transferNewMedias', //批量转交转交媒体
    getBatchAddData: serviceHost + 'newMedia/myTaskData', //批量添加暂存数据
    getTempBatchAddData: serviceHost + 'newMedia/taskList', //批量新增临时暂存数据
    batchAddTemp: serviceHost + 'newMedia/tempStorage', //批量新增暂存
    batchAddSimpleAdd: serviceHost + 'newMedia/addSingleData', //批量新增单个添加
    batchAddUpdateSimple: serviceHost + 'newMedia/editSingleData', //批量新增单个添加
    exportMediaData: serviceHost + 'fileHandler/outputNewMedia', //导出媒体
    getOverTask: serviceHost + 'newMedia/removeImport', //结束批量新增任务
    batchAddSave: serviceHost + 'newMedia/confirmImport', //批量新增保存
    getMediaGradeData: serviceHost + 'newMedia/gradeCount', //媒体等级数量
    getWechatList: "/newmedia-data-consumer/contentManager/getWeChatList", //微信
    getWeiBoList: "/newmedia-data-consumer/contentManager/getWeiBoList", //微博
    getDouYinList: "/newmedia-data-consumer/contentManager/getDouyinList", //抖音
    getFlowEndData:'/cm-sites-activiti/activitiAdmin/interruptProcessNotDelData',//批量转交后流程结束
    getCurrentUser: '/cm-sites-sys/user/getCurrentUser',//获取当前用户
};

export const getTodoListList = (params, callBack) => {
    let url = "/cm-sites-sys/process/getTodoList";
    request({
        url,
        method: 'POST',
        body: params,
        contentType: "json",
        callBack: (data) => {
            // 此处获取的结果集是审核流程中的数据，在未推进流程的情况下，本地数据和流程中数据可能存在差异，需要根据结果集中素材ID在本地数据中再查询一次
            let mediaId = [];
            let mediaCodes = [];
            let _data = data.data;
            _data.forEach(item => {
                mediaId.push(item.data.id);
                mediaCodes.push(item.data.code);
            });
            callBack(mediaId, mediaCodes);
        }
    });
};

export function getActHistory(body, callBack, message) {
    let url = '/cm-sites-sys/process/getProcessHistory';
    request({url, body, callBack, message: message});
}

export const getMeHandleCountData = (body, callBack) => {
    request({url: Apis.getMeHandleCountData, contentType: "json", method: "post", body, callBack});
};
export const getMediaGradeData = (body, callBack) => {
    request({url: Apis.getMediaGradeData, contentType: "json", method: "post", body, callBack});
};
export const getInitMediaPlatformData = (body, callBack) => {
    request({url: Apis.getInitMediaPlatformData, body, callBack});
};
export const getNewMediaListData = (body, callBack) => {
    request({url: Apis.getNewMediaListData, body, callBack});
};
export const getAllNewMediaList = (body, callBack) => {
    request({url: Apis.getAllNewMediaList, contentType: "json", method: "post", body, callBack});
};
export const getRecordDeptByIds = (body, callBack) => {
    request({url: Apis.getRecordDeptByIds, contentType: "json", method: "post", body, callBack});
};
export const getCurrentDeptByIds = (body, callBack) => {
    request({url: Apis.getCurrentDeptByIds, contentType: "json", method: "post", body, callBack});
};
export const addNewMedia = (body, callBack, message) => {
    request({url: Apis.addNewMedia, contentType: "json", method: "post", body, callBack, message: message});
};
export const updateNewMedia = (body, callBack, message) => {
    request({url: Apis.updateNewMedia, contentType: "json", method: "post", body, callBack, message: message});
};
export const getNewMediaById = (body, callBack) => {
    request({url: Apis.getNewMediaById, body, callBack});
};
export const getNewMediaList = (body, callBack) => {
    request({url: Apis.newMediaList, body, callBack});
};
export const checkName = (body, callBack, message) => {
    request({url: Apis.checkName, body, callBack, message: message});
};
export const checkDouyinLink = (body, callBack, message) => {
    request({url: Apis.checkDouyinLink, body, callBack, message: message});
};
export const cancelExport = (body, callBack) => {
    request({url: Apis.cancelExport, body, callBack});
};
export const addSingleData = (body, callBack, message) => {
    request({url: Apis.addSingleData, contentType: "json", method: "post", body, callBack, message: message});
};
export const editSingleData = (body, callBack, message) => {
    request({url: Apis.editSingleData, contentType: "json", method: "post", body, callBack, message: message});
};
export const batchUpdateNewMedia = (body, callBack, message) => {
    request({url: Apis.batchUpdateNewMedia, contentType: "json", method: "post", body, callBack, message: message});
};
export const cancelImport = (body, callBack, message) => {
    request({url: Apis.cancelImport, body, callBack, message: message});
};
export const deleteData = (body, callBack, message) => {
    request({url: Apis.deleteData, body, callBack, message: message});
};
export const deleteNewMediaById = (body, callBack) => {
    request({url: Apis.deleteNewMediaById, body, callBack});
};
export const updateNewMediaStatusName = (body, callBack, message) => {
    request({url: Apis.updateNewMediaStatusName, body, callBack, message: message});
};
export const getExcelTemplate = (body, callBack, message) => {
    request({url: Apis.getExcelTemplate, method: "downloadGet", body, callBack, message: message});
};
export const saveExcelTemplate = (body, callBack, message) => {
    request({url: Apis.saveExcelTemplate, contentType: "json", method: "post", body, callBack, message: message});
};
export const getTransferUsers = (body, callBack, message) => {
    request({url: Apis.getTransferUsers, contentType: "json", method: "post", body, callBack, message: message});
};
export const getBatchTransferNewMedias = (body, callBack, message) => {
    request({url: Apis.batchTransferNewMedias, method: "get", body, callBack, message: message});
};
export const transferNewMedias = (body, callBack, message) => {
    request({url: Apis.transferNewMedias, method: "get", body, callBack, message: message});
};
export const getBatchAddData = (body, callBack, message) => {
    request({url: Apis.getBatchAddData, body, callBack});
};
export const getTempBatchAddData = (body, callBack, message) => {
    request({url: Apis.getTempBatchAddData, body, callBack});
};
export const batchAddTemp = (body, callBack, message) => {
    request({url: Apis.batchAddTemp, body, callBack});
};
export const batchAddSimpleAdd = (body, callBack, message) => {
    request({url: Apis.batchAddSimpleAdd, contentType: "json", method: "post", body, callBack, message: message});
};
export const batchAddUpdateSimple = (body, callBack, message) => {
    request({url: Apis.batchAddUpdateSimple, contentType: "json", method: "post", body, callBack, message: message});
};
export const exportMediaData = (body, callBack, message) => {
    request({url: Apis.exportMediaData, method: "downloadGet", body, callBack, message: message});
};
export const getOverTask = (body, callBack) => {
    request({url: Apis.getOverTask, body, callBack});
};
export const batchAddSave = (body, callBack, message) => {
    request({url: Apis.batchAddSave, method: "get", body, callBack, message: message});
};
export const getWechatList = (body, callBack) => {
    request({url: Apis.getWechatList, body, callBack});
};
export const getWeiBoList = (body, callBack) => {
    request({url: Apis.getWeiBoList, body, callBack});
};
export const getDouYinList = (body, callBack) => {
    request({url: Apis.getDouYinList, body, callBack});
};
export const getFlowEndData = (body, callBack, message) => {
    // 流程结束接口如果报错，需要回调给页面。message
    request({url: Apis.getFlowEndData, method: "post", body, callBack, message: message});
};
export const getCurrentUser = (body, callBack) => {
    request({url: Apis.getCurrentUser, method: "post", body, callBack});
};
